import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Sprout, Leaf, Trees, Wind, Snowflake, Hammer, Layers, Sparkles, Check, ArrowRight, Phone, MapPin, Menu, X } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Sprout,
  Leaf,
  Trees,
  Wind,
  Snowflake,
  Hammer,
  Layers,
  Sparkles
};

const Services = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Premium Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-950/98 via-emerald-950/95 to-slate-950/98 backdrop-blur-xl border-b border-emerald-500/20 shadow-[0_4px_30px_rgba(16,185,129,0.15)]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20 md:h-28">
            <Link to="/" className="flex items-center group -ml-2 md:-ml-4 mt-1 md:mt-2">
              <div className="relative">
                <div className="absolute -inset-2 md:-inset-3 bg-gradient-to-r from-emerald-500/40 via-green-400/30 to-emerald-500/40 rounded-2xl blur-xl opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="relative h-16 md:h-24 w-auto rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_60px_rgba(16,185,129,0.3)] border-2 border-emerald-400/30"
                  style={{filter: 'drop-shadow(0 0 20px rgba(16,185,129,0.4))'}}
                />
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/services" className="relative text-emerald-400 font-bold text-sm uppercase tracking-wider">
                Services
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-emerald-400 to-green-400"></span>
              </Link>
              <Link to="/gallery" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Gallery
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/values" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Our Values
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/testimonials" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Testimonials
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/faq" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                FAQ
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Button 
                onClick={scrollToContact} 
                className="relative overflow-hidden bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 hover:from-emerald-500 hover:via-green-400 hover:to-emerald-500 text-white font-bold px-8 py-3 rounded-full shadow-[0_4px_20px_rgba(16,185,129,0.4)] transition-all duration-300 border border-emerald-400/30"
              >
                Get a Quote
              </Button>
            </nav>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-white hover:text-emerald-400 transition-colors"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-slate-950 border-b border-emerald-500/20 shadow-2xl z-50">
            <nav className="container mx-auto px-6 py-6 flex flex-col gap-1">
              <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="text-emerald-400 font-semibold text-lg py-3 px-4 rounded-lg bg-emerald-500/10">Services</Link>
              <Link to="/gallery" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Gallery</Link>
              <Link to="/values" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Our Values</Link>
              <Link to="/testimonials" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Testimonials</Link>
              <Link to="/faq" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">FAQ</Link>
              <Button onClick={() => { scrollToContact(); setMobileMenuOpen(false); }} className="mt-4 bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 text-white font-bold px-8 py-3 rounded-full shadow-lg">Get a Quote</Button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section - Unique diagonal design */}
      <section className="relative pt-24 pb-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-emerald-950/30 to-slate-900"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-emerald-600/10 to-transparent skew-x-12 transform origin-top-right"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10 pt-20">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8">
              <Leaf className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm font-semibold uppercase tracking-widest">What We Offer</span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
              Our <span className="bg-gradient-to-r from-emerald-400 to-green-400 bg-clip-text text-transparent">Services</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl leading-relaxed">
              Comprehensive landscaping and property maintenance services designed for Alberta's unique climate. 
              Professional care for residential and commercial properties, year-round.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="relative py-24 px-4 lg:px-8 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="absolute inset-0 opacity-[0.02]" style={{backgroundImage: 'radial-gradient(circle at 1px 1px, #10b981 1px, transparent 0)', backgroundSize: '40px 40px'}}></div>
        
        <div className="container mx-auto relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              const serviceSlug = service.customPage || `/services/${service.title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`;
              
              return (
                <Card key={service.id} className="group relative overflow-hidden bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm border-2 border-slate-700/50 hover:border-emerald-500/50 rounded-3xl transition-all duration-500 hover:shadow-[0_20px_60px_rgba(16,185,129,0.15)]">
                  {/* Animated gradient border */}
                  <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-500 via-green-400 to-emerald-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                  
                  {/* ASM Badge for Snow Removal */}
                  {service.badge && (
                    <div className="absolute top-4 right-4 bg-white rounded-lg p-2 shadow-lg">
                      <img 
                        src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/1valnauv_ASM%20Logo.png" 
                        alt="SIMA ASM Certified" 
                        className="h-8 w-auto"
                      />
                    </div>
                  )}
                  
                  <CardHeader className="pt-8">
                    <div className="relative mb-6">
                      <div className="absolute inset-0 bg-emerald-400/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                      <div className="relative w-16 h-16 bg-gradient-to-br from-emerald-600 via-green-500 to-emerald-600 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-lg">
                        <IconComponent className="w-8 h-8 text-white" />
                      </div>
                    </div>
                    <CardTitle className="text-2xl font-black text-white mb-3 group-hover:text-emerald-400 transition-colors">{service.title}</CardTitle>
                    <CardDescription className="text-gray-400 text-base leading-relaxed">{service.description}</CardDescription>
                  </CardHeader>
                  
                  <CardContent className="pb-8">
                    <ul className="space-y-3 mb-6">
                      {service.features.slice(0, 3).map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-3 text-gray-300">
                          <div className="w-5 h-5 mt-0.5 rounded-full bg-gradient-to-br from-emerald-500 to-green-500 flex items-center justify-center flex-shrink-0">
                            <Check className="w-3 h-3 text-white" />
                          </div>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Link to={serviceSlug}>
                      <Button className="w-full bg-slate-700 hover:bg-emerald-600 text-white font-semibold rounded-xl transition-all duration-300 group-hover:shadow-lg border border-slate-600 hover:border-emerald-500">
                        Learn More
                        <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 px-4 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 via-green-600 to-emerald-600"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.1)_0%,_transparent_70%)]"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
        
        <div className="container mx-auto text-center relative z-10">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-6">Ready to Transform Your Property?</h2>
          <p className="text-xl text-emerald-100 mb-10 max-w-2xl mx-auto">
            Get a free consultation and quote for your landscaping or snow removal needs.
          </p>
          <Button 
            onClick={scrollToContact} 
            size="lg" 
            className="bg-white text-emerald-700 hover:bg-gray-100 px-10 py-7 text-xl font-bold rounded-2xl shadow-2xl hover:shadow-white/20 transition-all duration-300"
          >
            Get Free Quote
            <ArrowRight className="ml-3 w-6 h-6" />
          </Button>
        </div>
      </section>

      {/* Premium Footer */}
      <footer className="relative bg-gradient-to-b from-slate-900 to-black text-gray-300 pt-20 pb-8 px-4 lg:px-8">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
        
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-16">
            <div className="md:col-span-2">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="h-16 w-auto rounded-xl"
                />
                <div>
                  <span className="text-lg font-black text-white">TRUE NORTH</span>
                  <span className="block text-xs text-emerald-400 tracking-[0.2em]">ALBERTA PROPERTY SERVICES</span>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed max-w-md">
                Professional landscaping and snow removal services for Alberta properties. Quality work, reliable service, year-round excellence.
              </p>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Quick Links</h3>
              <ul className="space-y-3">
                <li><Link to="/services" className="text-gray-400 hover:text-emerald-400 transition-colors">Services</Link></li>
                <li><Link to="/gallery" className="text-gray-400 hover:text-emerald-400 transition-colors">Gallery</Link></li>
                <li><Link to="/values" className="text-gray-400 hover:text-emerald-400 transition-colors">Our Values</Link></li>
                <li><Link to="/testimonials" className="text-gray-400 hover:text-emerald-400 transition-colors">Testimonials</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Contact</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-emerald-400" />
                  <span className="text-gray-400">Calgary & Surrounding Areas</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-emerald-400" />
                  <a href="tel:5873252799" className="text-gray-400 hover:text-emerald-400 transition-colors">587-325-2799</a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-slate-800 pt-8 text-center">
            <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} True North Alberta Property Services. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Services;
